<template>
    <div class="paySuccess main center">
        <Icon type="md-checkmark-circle-outline" size="60" color="green"/>
        <!-- <h2 class="paySuccess-title"></h2> -->
        <p class="paySuccess-subtitle">批改成功</p>
        <Button type="primary" @click="detail">查看详情</Button>
    </div>
</template>
<script>
export default {
    data(){
        return {
            id:this.$route.params.id||''
        }
    },
    methods: {
        detail() {
            location.href=`/haierProduct.html#/my/customizedTPL/riderDetail/${this.id}`
        }
    },
}
</script>
<style scoped lang="less">
.paySuccess{
    padding:50px 20px;
    &-title{
        margin-top: 20px;
    }
    &-subtitle{
        color: red;
        font-size: 14px;
        margin-top: 10px;
        margin-bottom: 30px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/editsuccess.vue